import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'
import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router'
import { DEFAULT_META, getCustomMeta } from 'config/constants/meta'
import Container from './Container'

const StyledPage = styled(Container)`
  min-height: calc(50vh - 64px);
  padding-top: 16px;
  padding-bottom: 16px;
  position: relative;
  z-index: 1;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding-top: 24px;
    padding-bottom: 24px;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    padding-top: 32px;
    padding-bottom: 32px;
  }
`

const PageMeta = () => {
  const { t } = useTranslation()

  let { title, description, image } = DEFAULT_META
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { pathname } = useLocation()
    const pageMeta = getCustomMeta(pathname, t) || {}
    const mergedMeta = { ...DEFAULT_META, ...pageMeta }

    // eslint-disable-next-line prefer-destructuring
    title = mergedMeta.title
    // eslint-disable-next-line prefer-destructuring
    description = mergedMeta.description
    // eslint-disable-next-line prefer-destructuring
    image = mergedMeta.image
  } catch (err) {
    console.debug('PageMeta failed')
  }
  const pageTitle = title

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
    </Helmet>
  )
}

const Page: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, ...props }) => {
  return (
    <>
      <PageMeta />
      <StyledPage {...props}>{children}</StyledPage>
    </>
  )
}

export default Page
